// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const JobDetailHeader = styled.div`
  padding-bottom: 16px;
`;
JobDetailHeader.displayName = 'S.JobDetailHeader';

export const TopAlignFlex = styled.div`
  display: flex;
  align-items: flex-start;
`;
TopAlignFlex.displayName = 'S.TopAlignFlex';

export const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
`;
CenteredFlex.displayName = 'S.CenteredFlex';

export const RighthandPanel = styled.div`
  text-align: right;
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
`;
RighthandPanel.displayName = 'S.RighthandPanel';
